import React, {Component} from "react";
import {Image} from "react-bootstrap";
import DetailsColumn from "./DetailsColumn";

import '../../../../assets/sass/pages/talent-search/team-and-transfer.scss';
class TeamAndTransferItem extends Component {
    render = () => {
        const {title, name, logo, description} = this.props;

        return (
            <div className="team-and-transfer-item">
                <div className="title"> {title} </div>
                <div className="details-container">
                    <div className="team-avatar">
                        <Image src={logo} fluid/>
                    </div>
                    <div className="team-details">
                        <div className="name"> {name} </div>
                        <div className="description"> {description} </div>
                    </div>
                </div>
            </div>
        );
    };
}

class TeamAndTransfer extends DetailsColumn {
    renderBody = () => {
        const {data} = this.props;

        if (!data)
            return "OOPS! No data provided!";

        const currentTeam = data.currentTeam;
        const transferredFrom = data.transferredFrom;

        return (
            <div className="team-and-transfer-body">
                <TeamAndTransfer.Item title="Current Team" name={currentTeam.name} description={currentTeam.description} logo={currentTeam.logo}/>
                <TeamAndTransfer.Item title="Transfered From" name={transferredFrom.name} description={transferredFrom.description} logo={transferredFrom.logo}/>
            </div>
        );
    };


    static defaultProps = {
        headerTitle: "Team and Transfer"
    };

    getComponentClassName = () => 'team-and-transfer';
}

TeamAndTransfer.Item = TeamAndTransferItem;
export default TeamAndTransfer;
